import Container from '../../Container/Container'
import ProductCard from '../../ProductCardAll/ProductCard/ProductCard';
import React, { Fragment, useContext } from 'react'
import { Pagination, Navigation, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { DataContext } from '../../Context/Context'
import offer from '../../../assets/images/discountpng.webp'
import "./LatestProducts.css"


function LatestProducts() {
    const value = useContext(DataContext);
    const [products, setProducts] = value.products;
    return (
        <>
            <Container class1='container-fluid bg-img-latest'>
                <div className="row rounded">
                    <div className="col-12">
                        <Swiper
                            slidesPerView={1}
                            breakpoints={{
                                500: { slidesPerView: 2},
                                768: { slidesPerView: 3 },
                                1000: { slidesPerView: 4 },
                                1200: { slidesPerView: 5 }
                            }}
                            spaceBetween={10}
                            freeMode={true}
                            navigation={true}
                            modules={[FreeMode, Pagination, Navigation]}
                            className="mySwiper"
                        >
                            <div className="row">
                                <div className="col-12">
                                    {
                                        products.map((product, index) => (
                                            <Fragment key={product._id}>
                                                <SwiperSlide key={product._id}  >
                                                    <ProductCard product={product} classes=' ' />
                                                </SwiperSlide>
                                                {
                                                    index === 1 && (
                                                        <SwiperSlide >
                                                            <div className="">
                                                                <figure>
                                                                    <figcaption className='h4 text-center py-4 fw-bold text-danger'> آخرین محصولات تایتان </figcaption>
                                                                    <img src={offer} className='img-fluid pt-5' alt="" />
                                                                </figure>
                                                            </div>
                                                        </SwiperSlide>
                                                    )
                                                }
                                            </Fragment>
                                        ))
                                    }
                                </div>
                            </div>
                        </Swiper>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default LatestProducts